import React from "react"
import tw from "twin.macro"

interface Props {
  children: React.ReactNode
  className?: string
}

export const Card: React.FC<Props> = ({ children, className }) => {
  return <Wrapper className={className}>{children}</Wrapper>
}

const Wrapper = tw.div`bg-white rounded-md`
